import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Workshop } from "../services/firebase";
import LocationIcone from "../assets/icone/LocationIcone";
import "./WorkshopCard.css";
import PrimaryButton from "./PrimaryButton";

import Logo from "assets/image/Logo";

interface WorkshopCardProps {
  workshop: Workshop;
  inView?: boolean;
}

const WorkshopCard: React.FC<WorkshopCardProps> = ({
  workshop,
  inView = true,
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // Get current language
  const currentLanguage = i18n.language;

  // Get localized content based on current language
  const getLocalizedTitle = () => {
    if (currentLanguage === "ru" && workshop.titleRu) {
      return workshop.titleRu;
    }
    return workshop.title;
  };

  const getLocalizedLocation = () => {
    if (currentLanguage === "ru" && workshop.locationRu) {
      return workshop.locationRu;
    }
    return workshop.location || t("location");
  };

  // Check if workshop has available dates
  const hasAvailableDates =
    workshop.dates &&
    workshop.dates.length > 0 &&
    workshop.dates.some((date) => date.isAvailable);

  const availableDatesCount = workshop.dates
    ? workshop.dates.filter((date) => date.isAvailable).length
    : 0;

  const handleCardClick = () => {
    navigate(`/workshops/${workshop.id}`);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardClick();
    }
  };

  return (
    <div
      className={`workshop-card${inView ? "" : " inactive"}`}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`${getLocalizedTitle()} - ${t("workshopDetails") || "פרטי הסדנה"}`}
      data-language={i18n.language}
    >
      <div className="workshop-image">
        {workshop.imageUrl &&
        workshop.imageUrl !== "" &&
        workshop.imageUrl !== "safa" &&
        workshop.imageUrl.startsWith("http") ? (
          <img src={workshop.imageUrl} alt={workshop.title} />
        ) : (
          <Logo />
        )}
      </div>

      <div className="workshop-content">
        <h3 className="workshop-title-card">{getLocalizedTitle()}</h3>

        <div className="workshop-location">
          <LocationIcone className="location-icon" />
          <span>{getLocalizedLocation()}</span>
        </div>

        <div className="workshop-availability">
          <div className="availability-status">
            {hasAvailableDates ? (
              <>
                <div className="availability-dot available"></div>
                <span className="availability-text available">
                  {" "}
                  {t("available")}
                </span>
              </>
            ) : (
              <>
                {/* <div className="availability-dot unavailable"></div>
                <span className="availability-text unavailable">
                  {t("unavailable")}
                </span> */}
              </>
            )}
          </div>
          <div className="workshop-price">₪{workshop.price}</div>
        </div>

        <PrimaryButton fullWidth={true} disabled={!hasAvailableDates}>
          {t("register")}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default WorkshopCard;
